import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMStrategiesEdit } from "./edit";
import { A7OPCVMStrategiesTable } from "./table";

export default function A7OPCVMStrategies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Fonds");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMStrategiesEdit />} />
      <Route index element={<A7OPCVMStrategiesTable />} />
    </Routes>
  );
}
